import { mapMatchStatus, processTestFiltersResponse } from '../strategy/testFiltersStrategyUtils';
export const parseDebugFilterBranchEvaluationResponse = (response, objectTypeId, internalDraftValue) => {
  if (!response || !Array.isArray(response)) {
    return undefined;
  }
  const filtersStatus = mapMatchStatus(response[0]['@ok'].acceptedStatus);
  const branches = response[0]['@ok'].filterBranches;
  const result = branches.map(group => {
    var _group$filters, _group$filterBranches;
    const obj = {
      status: mapMatchStatus(group.acceptedStatus),
      filtersData: (_group$filters = group.filters) === null || _group$filters === void 0 ? void 0 : _group$filters.map(filter => {
        var _filter$filter, _evaluationData$match, _evaluationData$nonMa, _filter$filter2;
        const evaluationData = filter.evaluationData[0];
        const filterDataObject = {
          filterType: (_filter$filter = filter.filter) === null || _filter$filter === void 0 ? void 0 : _filter$filter.filterType,
          firstMatchingPropertyValue: evaluationData === null || evaluationData === void 0 || (_evaluationData$match = evaluationData.matchingPropertyValuesOrdered) === null || _evaluationData$match === void 0 ? void 0 : _evaluationData$match[0],
          firstNonMatchingPropertyValue: evaluationData === null || evaluationData === void 0 || (_evaluationData$nonMa = evaluationData.nonMatchingPropertyValuesOrdered) === null || _evaluationData$nonMa === void 0 ? void 0 : _evaluationData$nonMa[0],
          matchingFilterValues: evaluationData === null || evaluationData === void 0 ? void 0 : evaluationData.matchingFilterValues,
          operator: (_filter$filter2 = filter.filter) === null || _filter$filter2 === void 0 || (_filter$filter2 = _filter$filter2.operation) === null || _filter$filter2 === void 0 ? void 0 : _filter$filter2.operator,
          propertyValue: (evaluationData === null || evaluationData === void 0 ? void 0 : evaluationData.propertyValue) || (evaluationData === null || evaluationData === void 0 ? void 0 : evaluationData.propertyValueHistory),
          status: mapMatchStatus(filter.acceptedStatus)
        };
        return filterDataObject;
      }),
      filterBranchesData: (_group$filterBranches = group.filterBranches) === null || _group$filterBranches === void 0 ? void 0 : _group$filterBranches.map(filter => mapMatchStatus(filter.acceptedStatus))
    };
    return obj;
  });
  const filtersData = processTestFiltersResponse(objectTypeId, internalDraftValue, result);
  return {
    filtersData,
    filtersStatus
  };
};